import React from 'react'
import { INewCaptureInfo } from '../../types'
import CaptureInfoManager from './manager'
import SectionButtons from './section-buttons'
import Sections from './sections'

type Props = {
    className?: string
    captureInfo?: INewCaptureInfo
    uploadProgress?: number
    isUploading?: boolean
    saveLabel: string
    onSave: (info: INewCaptureInfo) => void
    onUpdate?: (hasChanges: boolean) => void
    onCancel: () => void
}

const CreationCaptureInfo = ({
    className,
    captureInfo,
    uploadProgress,
    isUploading = false,
    saveLabel,
    onSave,
    onUpdate,
    onCancel,
}: Props) => {
    return (
        <CaptureInfoManager
            {...{
                defaultTitle: captureInfo?.title,
                defaultTags: captureInfo?.tags,
                defaultUsername: captureInfo?.username,
                defaultWatermark: captureInfo?.watermark,
                defaultFont: captureInfo?.font,
                defaultSourceUrl: captureInfo?.sourceUrl,
                defaultRating: captureInfo?.rating,
                onUpdate,
            }}
        >
            <Sections className={className} />
            <SectionButtons
                {...{
                    className: className,
                    defaultLabel: saveLabel,
                    uploadProgress: uploadProgress,
                    isUploading: isUploading,
                    defaultOnSave: onSave,
                    defaultOnCancel: onCancel,
                    defaultOnUpdate: onUpdate,
                }}
            />
        </CaptureInfoManager>
    )
}

export default CreationCaptureInfo
